<template>
	<div class="ContingentOrders" ref="root"
		style="width: 100%;"
	>
		<!-- Status Filter Section -->
		<StatusFilter
			v-model="statusFilters"
			:loading="loading"
			@apply="applyStatusFilter"
			@clear="clearStatusFilter"
		/>

		<v-data-table fixed-header
			:headers="ordersHeaders"
			:items="filteredOrderItems"
			item-key="from"
			class="elevation-0"
			:items-per-page="1000"
			:item-value="item => item"
		>
			<template #item="{ item }">
				<tr @click="showOrder(item)">
					<td>{{ item.order_id }} - {{ item.order_item_id }}</td>
					<td style="white-space: nowrap;">{{ formatDateTime(item.order_date) }}</td>
					<!--<td>{{ item.client_name }}</td>-->
					<td>{{ item.customer.firstname }} {{ item.customer.lastname }}</td>
					<td :style="{ color: getStatusColor(item.status) }">{{ getStatusLabel(item.status) }}</td>
					<td></td>
				</tr>
			</template>
			<template #bottom></template>
		</v-data-table>
		<div v-if="filteredOrderItems?.length > 3">
			{{ filteredOrderItems?.length }} {{ filterSummaryText }}
		</div>
		<p class="helpText" v-html="$t('text.cmOrdersHelp')" />
		<DialogV2 ref="orderDetailDialog"
			title="Order"
			@close="selected = null"
		>
			<template #content>
				<OrderDetailView embedded />
			</template>
		</DialogV2>
	</div>
</template>

<script>
import OrderDetailView from '../../../views/applications/orders/OrderDetailView.vue'
import DialogV2 from '../../common/DialogV2.vue'
import StatusFilter from '../../common/StatusFilter.vue'
import Loading from '../../../mixins/Loading.vue'
import Common from '../../../mixins/Common.vue'

export default {
	components: { OrderDetailView, DialogV2, StatusFilter },
	mixins: [Loading, Common],
	props: {
		orderItems: Array,
	},
	data: () => ({
		selected: null,
		statusFilters: [],
		filteredOrderItems: [],
	}),
	computed: {
		ordersHeaders() {
			return [
				{ title: 'ID', key: 'orderId', width: '15%', sortable: false },
				{ title: this.$t('text.orderDate') , key: 'orderDate', width: '15%', sortable: false },
				//{ title: this.$t('text.marketplace') , key: 'marketplace', width: '15%', sortable: false },
				{ title: this.$t('text.customerName') , key: 'customerName', width: '15%', sortable: false },
				{ title: this.$t('text.status'), key: 'status', width: '5%', sortable: false, align: 'left' },
				{ title: '', key: 'viewOrder', width: '5%', sortable: false, align: 'center' },
			]
		},
		filterSummaryText() {
			if (!this.statusFilters || this.statusFilters.length === 0) {
				return this.$t('text.ordersAndCancellations')
			}
			
			const statusLabels = this.statusFilters.map(status => {
				switch(status) {
					case 'Ordered': return this.$t('text.ordered')
					case 'Cancelled': return this.$t('text.cancelled')
					default: return status.toLowerCase() + ' items'
				}
			})
			
			if (statusLabels.length === 1) {
				return statusLabels[0]
			}
			else if (statusLabels.length === 2) {
				return statusLabels.join(` ${this.$t('text.and')} `)
			}
			else {
				const lastItem = statusLabels.pop()
				return statusLabels.join(', ') + `, ${this.$t('text.and')} ` + lastItem
			}
		},
	},
	methods: {
		showOrder(item) {
			console.log(item)
			item = JSON.parse(JSON.stringify(item))
			item.client_id = this.$store.state.selectedClient.sys.id
			// NOTE: service currently does not use SP id
			item.service_provider_id = 'TODO'

			this.selected = item
			this.$store.state.selectedOrder = item
			this.$refs.orderDetailDialog.open()
		},
		getStatusColor(status) {
			if (!status || Object.keys(status).length == 0) return 'white'
			if (parseInt(status.refunded) === 1) return 'red'
			if (parseInt(status.canceled) === 1) return 'red'
			if (parseInt(status.shipped) === 1) return 'green'
			if (parseInt(status.invoiced) === 1) return 'green'
			if (parseInt(status.ordered) === 1) return 'blue'
		},
		getStatusLabel(status) {
			if (!status || Object.keys(status).length == 0) return
			if (parseInt(status.refunded) === 1) return this.$t('text.Cancelled')
			if (parseInt(status.canceled) === 1) return this.$t('text.Cancelled')
			if (parseInt(status.shipped) === 1) return this.$t('text.Shipped')
			if (parseInt(status.invoiced) === 1) return this.$t('text.Invoiced')
			if (parseInt(status.ordered) === 1) return this.$t('text.Ordered')
		},
		applyStatusFilter() {
			this.filteredOrderItems = this.orderItems.filter(item => {
				for (const statusFilter of this.statusFilters) {
					if (statusFilter === 'ordered' && item.status.ordered === 1 && item.status.canceled !== 1 && item.status.refunded !== 1) {
						return true
					}
					if (statusFilter === 'cancelled' && (parseInt(item.status.refunded) === 1 || parseInt(item.status.canceled) === 1)) {
						return true
					}
				}
				return false
			})
		},
		clearStatusFilter() {
			this.statusFilters = []
			this.filteredOrderItems = this.orderItems
		},
	},
	onMounted() {
		this.filteredOrderItems = this.orderItems
	},
	watch: {
		orderItems(newVal) {
			this.filteredOrderItems = newVal
		},
	},
}
</script>

<style>
.ContingentOrders .v-data-table td { font-size: 1rem !important; }

.export-actions-section {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin: 16px 0;
	padding: 12px 0;
	border-bottom: 1px solid #e0e0e0;
}

.export-excel-btn {
	font-weight: 500;
	text-transform: none;
	letter-spacing: 0.5px;
}

.export-excel-btn .v-icon {
	margin-right: 8px;
}
</style>